// import '../../node_modules/masonry-layout/dist/masonry.pkgd';
// import '../../node_modules/imagesloaded/imagesloaded.pkgd';

const MasonryGrid = (gridClass, itemClass, itemContentClass) => {
  document.querySelectorAll(gridClass).forEach(grid => {
    const msnry = new Masonry(grid, {
      itemSelector: itemClass,
      columnWidth: itemClass,
      percentPosition: true,
    });

    imagesLoaded(grid).on('progress', function () {
      msnry.layout();
    });
  });
}

export default MasonryGrid;
